module.exports = __webpack_public_path__ + "img/Showtime-text.a09bc1e7.jpg";